import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=6366b08f"
import script from "./newsletter.vue?vue&type=script&lang=ts"
export * from "./newsletter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchWrapper: require('/usr/src/nuxt-app/components/core/SearchWrapper.vue').default,ElementsNewsletterForm: require('/usr/src/nuxt-app/components/elements/NewsletterForm.vue').default})
